///function to check if a particular object is an array
///and return an array of empty strings if not
export default function checkIfArray(obj) {
  return Array.isArray(obj) ? obj : ["", ""];
}
